import { useQuery } from "@tanstack/react-query";
import MacroEquation from "../../components/MacroEquation";
import { IUser } from "../../models";
import styles from "./styles.module.scss";
import { getUserCalorieGoal } from "../../services/users.service";
import dayjs from "dayjs";
import { IconButton } from "../../components";
import { NotificationIcon } from "../../assets";
import { useState } from "react";
import { UpdateUserRecommendation } from "../../modals";

type UserDailyDeficitProps = {
  user: IUser;
  refetchUser?: () => void;
};

const UserDailyDeficit: React.FC<UserDailyDeficitProps> = ({
  user,
  refetchUser,
}) => {
  const { data } = useQuery({
    queryKey: ["user-calorie-goal", user?.id],
    queryFn: () => {
      return getUserCalorieGoal(user?.id);
    },
  });

  const [isShowUpdateUserRecommendation, setIsShowUpdateUserRecommendation] =
    useState(false);

  return (
    <div className={styles.wrapper}>
      {refetchUser && (
        <UpdateUserRecommendation
          isOpen={isShowUpdateUserRecommendation}
          setIsOpen={setIsShowUpdateUserRecommendation}
          user={user}
          refetchUser={refetchUser}
        />
      )}
      <p className={styles.title}>Daily Deficit</p>
      <p className={styles.updatedDate}>
        Updated:{" "}
        {dayjs
          .utc(user?.lastRecommendation?.date || user?.onboardingAt)
          .format("MM/DD/YYYY")}
      </p>
      <div>
        <p className={styles.infoTitle}>
          Method:{" "}
          <span>
            {user?.tracker && data?.hasCustomMacros
              ? "Custom Intake - Tracker"
              : user?.tracker && !data?.hasCustomMacros
              ? "Standard - Tracker"
              : !user?.tracker && data?.hasCustomMacros
              ? "Custom Intake - Manual"
              : "Standard - Manual"}
          </span>
        </p>
        <p className={styles.infoTitle}>
          Pace: <span>{user?.weightLossMode}</span>
        </p>
      </div>
      <MacroEquation
        eat={data?.recommendedDailyIntake || 0}
        burn={data?.tdee || 0}
      />
      {refetchUser && (
        <IconButton
          title="Override"
          onClick={() => setIsShowUpdateUserRecommendation(true)}
        />
      )}
    </div>
  );
};

export default UserDailyDeficit;
